import React, { useState, useEffect, useRef } from 'react';
import { commonUrl } from '../api/config';
import Layout from '../../components/Layout';
import Header from '../../components/Header';
import SubHeader from '../../components/SubHeader';
import Footer from '../../components/Footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/Contentview.module.css';
import parse, { domToReact } from 'html-react-parser';
import Player from "../../components/Player";
import Navigator from './navigator';
import RelatedArticle from './relatedArticle';
import ArticleHeader from './articleHeader';
import Toast from 'react-bootstrap/Toast'
import * as LIB from '../../lib/common';

import InnerHTML from 'dangerously-set-html-content';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faPlayCircle } from '@fortawesome/free-solid-svg-icons';

function Article({ data }) {
    const [postData, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [dataID, setDataID] = useState(0);
    const [moduleForumLiteData, setModuleData] = useState();
    const [txtFontsize, setTxtFontsize] = useState(20);
    const [txtLineheight, setTxtLineheight] = useState(1.5);
    const [showSmHeader, setShowSmHeader] = useState(false);
    const [songInfo, setSongInfo] = useState([]);
    const [topicName, setTopicName] = useState('···');
    const [topicPath, setTopicPath] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastText, setToastText] = useState('');
    const [toastTimer, setToastTimer] = useState(null);
    const downloadIcon = <FontAwesomeIcon icon={faFileDownload} />;
    const playIcon = <FontAwesomeIcon icon={faPlayCircle} />;
    const playerRef = useRef();

    function hongkongDate() {
        let d = new Date();
        let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        let hkDate = new Date(utc + (3600000 * 8)); // HK +8 timezone;
        return hkDate;
    }

    useEffect(() => {
        async function runEff(){
            if (data) {
                let postDate = new Date(data.post_date.replace("T", " ").replace('.000Z', ''));
                if (postDate > hongkongDate()) {
                    let previewCode = '';
                    if (window.location.href.indexOf('?preview=') > 0) {
                        previewCode = window.location.href.split('?preview=')[1];
                        alert("你正在預覧未出街文章，請不要隨處分享此特殊連結！");
                    }
    
                    if (previewCode != Math.floor(data.id * 47 / 10) + 94) {
                        data.title = '暫未有資料...';
                        data.content = '暫未有資料...';
                    }
                }
    
                setData(data);
                setDataID(data.id);
                setIsLoading(false);
                //getHeadData(data);
                getSongInfo(data.lyrics); // data.lyrics is the song ID
                getModule(data.id);
            }
    
            if (typeof window !== "undefined") {
                calStickHeader()
            }
        }

        runEff();
        return () => {};
    }, []);

    const calStickHeader = () => {
        let oldValue = 0;
        let newValue = 0;
        window.addEventListener("scroll", () => {
            newValue = window.pageYOffset;
            if (oldValue < newValue) {
                //scrolling down
                if (window.pageYOffset > 130) {
                    setShowSmHeader(true);
                }
            } else if (oldValue > newValue) {
                //scrolling up
                if (window.pageYOffset < 230) {
                    setShowSmHeader(false);
                }
            }
            oldValue = newValue;
        });
    }

    const getSongInfo = async (songId) => {
        if (songId) {
            let url = commonUrl.lyrics + songId;
            const res = await fetch(url);
            const songInfo = await res.json();
            setSongInfo(songInfo);
        }
    }

    const getModule = async (articleID) => {
        //get external module, e.g.:forum_lite, etc.
        let url = process.env.domain + "/3.0/include/module_loader.php?id=" + articleID;
        fetch(
            url, { method: 'GET' }
        ).then((response) => {
            if (response.ok) {
                return response.text();
            }
        }).then((html) => {
            if (html) {
                
                setModuleData(html);
            }
        }).catch((error) => {
            console.log(error)
        });
    }

    const getHeadData = (article) => {
        if (article) {
            let data = [];
            data['title'] = article.title;
            data['url'] = process.env.domain + dataID;
            if (article.wallpaper) {
                data['image'] = article.wallpaper
            }

            setHeadData(data);
        }
    }

    const parseOptions = {
        replace: ({ attribs, children }) => {
            if (!attribs) {
                return;
            }

            if (attribs.id === 'post_api_content') {
                return (
                    <article id='post_api_content' className={styles.post_api_content} style={{ color: '#666666', fontSize: txtFontsize, lineHeight: txtLineheight, wordBreak: 'break-all' }}>
                        {domToReact(children, parseOptions)}
                    </article>
                );
            }
        }
    };

    const toggleToast = (text) => {
        setToastText(text);
        setShowToast(true);

        if (toastTimer != null) // reset any pending timeout otherwise the toast may disappear too fast
            clearTimeout(toastTimer);

        let timer = setTimeout(() => {
            setShowToast(false);
        }, 2000);
        setToastTimer(timer);
    }

    const handleTopicList = (topicData) => {
        let topic = topicData[data.topic_id];
        setTopicName(topic);
        setTopicPath(`/topics/${data.topic_id}/${topic}`);
    }

    const handleOnClickRelatedArticle = (article) => {
        if (playerRef.current) {
            playerRef.current.stop();
        }

        LIB.viewArticle(article.id, article.title, '_blank');
    }

    const renderLyrics = () => {
        if (songInfo && songInfo.lyrics && data.topic_id == '02a') {

            let rows = [];
            let i = 0;

            while (i < songInfo.lyrics.length) {
                rows.push(<div key={i}>{songInfo.lyrics[i]}</div>)
                i++;
            }

            if (songInfo.title == '已刪除' || songInfo.title == '') {
                return (<></>);
            }
            else {
                return (
                    <div className={styles.lyrics}>
                        <div className={styles.lyricsZNSLinkDiv}>
                            <a className={styles.lyricsZNSLink} target='_blank' href={'https://www.zionnewsong.com/' + songInfo.id}>{playIcon} ZionNewSong.com</a>
                        </div>
                        <div className={styles.lyricsTitle}>
                            ZNS {postData.lyrics}. {songInfo.title}
                        </div>
                        {rows}
                    </div>
                );
            }
        }
    }

    const renderDlWp = () => {
        if (postData.wallpaper && postData.wallpaper != '') {
            return (
                <div className={styles.downloadWallpaper}>
                    <a href={postData.wallpaper} download target='_blank' className={styles.downloadWallpaper}>
                        {downloadIcon} 下載背景圖
                    </a>
                </div>
            );
        }
    }

    const renderArticleContent = () => {
    
        if(postData.content != undefined && postData.topic_id == '05f'){
            // for yearbook article special style
            postData.content = (postData.content).replaceAll(/<h1>/g, "<h1 style='font-size:1.5rem;margin:20px 0 -13px 0;font-weight:500;border-left:5px solid #b2d6e5;padding-left:5px'>");
            postData.content = (postData.content).replaceAll(/<h2>/g, "<h2 style='font-size:1.3rem;margin:-5px 0  -30px -13px;font-weight:500;'>");
        }
            
        return (
            <div className={styles.alignCenter}>
                <div style={{ wordBreak: 'break-all' }}>
                    <div>{postData.content ? parse(`${postData.content}`, parseOptions) : <>載入中...</>}</div>
                    {renderDlWp()}
                    {renderLyrics()}
                    <div>
                        {moduleForumLiteData && <InnerHTML html={moduleForumLiteData} />}
                    </div>
                </div>
            </div>
        );
    }

    const renderBottomBar = (hasAudio) => {
        if(hasAudio){
            return(
                <Player ref={playerRef} source={postData.audio} article={postData}
                onToggleRepeat={(state) => toggleToast(state == '0' ? '停止重複播放' : (state == '1' ? '重複播放' : '自動播放下一篇'))}
                onToggleAuto={(state) => toggleToast(state ? '啟用自動開始播放' : '停止自動開始播放')} />
            );
        }
        else{
            return(<Navigator article={postData} />);
        }
    }

    if (postData) {
        return (
            <Layout>
                <Header getTopicData={handleTopicList} />
                <SubHeader data={[topicName, topicPath, postData.title]} />
                <Toast show={showToast} className={styles.toast}>
                    <Toast.Body>{toastText}</Toast.Body>
                </Toast>
                {
                    // Sticky Header when scrolling down
                }
                <div className={showSmHeader ? styles.showSmHeader : styles.smHeader}>
                    <Container className={styles.stickTitle}>
                        <ArticleHeader
                            postData={postData}
                            txtFontsize={txtFontsize}
                            setTxtFontsize={setTxtFontsize}
                            isSmHeader={showSmHeader ? true : false}
                        />
                    </Container>
                </div>

                {
                    // Main Content
                }
                <div className="viewport">
                    <div className="wrapper">
                        <Container style={{ padding: 0 }}>
                            <ArticleHeader
                                postData={postData}
                                txtFontsize={txtFontsize}
                                setTxtFontsize={setTxtFontsize}
                            />
                            <Row>
                                <Col><div className={styles.headerDivider}></div></Col>
                            </Row>
                            <Row>
                                <Col lg={8}>
                                    {renderArticleContent()}
                                </Col>
                                <Col lg={4} style={{ padding: 0 }}>
                                    <div className={styles.sticky}>
                                        <RelatedArticle data={postData.recent} header="最近文章" onclick={(article) => handleOnClickRelatedArticle(article)} />
                                        <RelatedArticle data={postData.related} header="相關文章" onclick={(article) => handleOnClickRelatedArticle(article)} />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>

                {
                    // Player or article navigator
                    isLoading === true ? <></> : renderBottomBar(postData.audio)
                }
                <Footer />
            </Layout>
        );
    } else {
        return (
            <>
                載入中...
            </>
        );
    }

}

export default Article;
